import React from 'react'
import { useSelector } from 'react-redux'
import { Stack, Grid, Box, Divider, Chip } from '@mui/material'
import { useForm } from 'react-hook-form'
import Input from 'components/generic/form/Input'
import Select from 'components/generic/form/Select'

const inputStyleProps = {
  item: true,
  md: 5,
  xs: 12,
}

const mockYards = [
  {
    id: 'lopez_houston',
    name: 'Lopez Houston',
  },
  {
    id: 'lopez_el_pasco',
    name: 'Lopez El Pasco',
  },
]

const Profile = () => {
  const { user } = useSelector(state => state.auth)

  const { handleSubmit, control } = useForm()

  // TODO implement
  const onSubmit = () => {}

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container p={3}>
          <Grid item md={10} xs={12}>
            <Grid item container rowSpacing={2} columnSpacing={{ xs: 2, md: 5 }}>
              <Grid item xs={12}>
                <Box>General Information</Box>
                <Box pt={1} pb={2}>
                  <Divider />
                </Box>
              </Grid>
              <Grid {...inputStyleProps}>
                <Input name="firstName" label="First Name" defaultValue="" control={control} />
              </Grid>
              <Grid {...inputStyleProps}>
                <Input name="lastName" label="Last Name" defaultValue="" control={control} />
              </Grid>
              <Grid {...inputStyleProps}>
                <Input name="email" label="Email" value={user?.attributes?.email || ''} control={control} disabled />
              </Grid>
              <Grid {...inputStyleProps}>
                <Input name="primaryPhone" label="Primary Phone" defaultValue="" control={control} />
              </Grid>

              <Grid item xs={12}>
                <Box mt={3}>Yard Access and Roles</Box>
                <Box pt={1} pb={2}>
                  <Divider />
                </Box>
                <Grid item xs={12} md={5}>
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Box>Yards</Box>
                    <Chip label="Lopez Houston" />
                    <Chip label="Lopez El Paso" />
                  </Stack>
                  <Box py={3}>
                    <Select
                      name="active-yard"
                      label="Active Yard"
                      defaultValue={mockYards[0].id}
                      control={control}
                      items={mockYards}
                    />
                  </Box>
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Box>Roles</Box>
                    <Chip label="Scale Operator" />
                    <Chip label="Cashier" />
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  )
}

export default Profile
